import { FlightTakeoffSharp } from "@mui/icons-material";
import { compareString } from "./utils";
import { THIC, WIFI_EXTENDER } from '../../../shared/utils/Constants';;



const formatProductName = (name: any) => {
  if (name !== undefined && name !== '') {
    const firstDigit: any = name?.match(/\d/);
    const indexed = name?.indexOf(firstDigit);
    return indexed;
  }
}



export const shouldApplyAffinityDiscount = (product: any, existingOrderDetails: any, cardType: string, productExist: boolean) => {
 
  const isAffinityDiscount = existingOrderDetails?.discountPlans?.find((element:any) => element?.productName === "Affinity Discount")?.affinityOccupation;
  const productServiceLevel = product?.offerResponse?.offerDetails?.serviceLevel;
  const existingServiceLevel = existingOrderDetails?.standardPlans?.find((element1:any) => element1?.planName?.includes("Internet"));
  const priceLockAvailable = existingOrderDetails?.priceLockC;
  if (
    (isAffinityDiscount && isAffinityDiscount?.length && isAffinityDiscount !== null &&
      productServiceLevel?.includes("1G") && !productExist) ||
    (isAffinityDiscount && productServiceLevel?.includes("2G") && cardType !== "voice" && cardType !== "noVoice" && !productExist)
  ) {
    return "discountChanged";
  } else if (isAffinityDiscount && isAffinityDiscount?.length && isAffinityDiscount !== null && cardType !== "voice" && cardType !== "noVoice"  && !productExist) {
    return "notEligible";
  }
  else if( (cardType !== "voice" && cardType !== "noVoice")  && (existingServiceLevel?.planName?.includes("200") || existingServiceLevel?.planName?.includes("500")) ) {
    return "loosingPlanSpeedTiers";
  } else if ((priceLockAvailable && priceLockAvailable !== null) &&
    (existingServiceLevel?.planName?.includes("2 Gig") && !productExist && cardType !== "voice" && cardType !== "noVoice")
  ) {
    return "nonAffinityPriceLock";
  }
  else if (cardType === "voice" || cardType === "noVoice") {
    return "voice";
  } else if (cardType !== "voice") {
    return "default";
  }
};

function convertDollarPriceNoTrailingZeros(value:any) {
  const formattedValue = value?.toString(10);
  return `$${formattedValue}`;
}

export const getSelectedProductDetail = (
  selectedProduct: any,
  cardType: string
): any => {
  if (cardType === "internet") {
    const { offerDetails } = selectedProduct?.offerResponse || { offerDetails: {} };
    return offerDetails;
  }
  return selectedProduct;
};

export const getProductDetail = (simplifiedProduct: any, product: any, cardType: string): any => {
  if (cardType === "internet") {
    return simplifiedProduct?.offerResponse?.offerDetails || {};
  }
  return product;
};

function extractGigProducts(result: any, flag: any) {
  if (!result?.productDetails) {
    return [];
  }

  return result?.productDetails?.filter((detail:any) =>
      detail?.offerResponse?.offerDetails?.productName?.toLowerCase().includes(flag?.toLowerCase())
    )
    ?.filter((detail:any) => detail?.offerResponse?.offerDetails?.affinity?.isAffinityApplicable)
    ?.map((detail:any) => ({
      
      name: detail?.offerResponse?.offerDetails?.affinity?.discountName,
      amount: detail?.offerResponse?.offerDetails?.priceResult?.length > 0 &&  detail?.offerResponse?.offerDetails?.priceResult[0]?.productCharge - detail?.offerResponse?.offerDetails?.priceResult[0]?.discountCharge ,
    }));
}
export const getFilteredItems = (
  cartResponse: any,
  existingOrderDetails: any,
  voiceRemoved: boolean,
  currentProduct: any,
  csm: any,
  productRes: any,
  planDetailsData?: any,
  selectedInternetProduct?:any,
  isAffinityApplicable?: any,
  selectedInternetChanged?: boolean
) => {
  const keywords = ["fiber", "voice", "tech",THIC,WIFI_EXTENDER];
  let result: any[]= [];
   const existingInternet = existingOrderDetails?.standardPlans?.find((element:any) => element?.productName?.toLowerCase().includes("internet"));
  let sameProd= selectedInternetProduct && Array.isArray(selectedInternetProduct) && selectedInternetProduct.length > 0 ? (selectedInternetProduct[0]?.productName?.toLowerCase()?.includes(existingInternet?.planName?.toLowerCase())): selectedInternetChanged === false ? true : false;
  const isAffinityDiscountApplicable = existingOrderDetails?.discountPlans?.find((element:any) => element?.productName === "Affinity Discount")?.affinityOccupation;
  // Determine the source of items based on voiceRemoved
  // below commneted code is not required aa cancel voice condtion changed from API end
  // const source = voiceRemoved
  //   ? [currentProduct?.offerResponse?.offerDetails]
  //   : cartResponse?.lineItems;

  const source = cartResponse?.lineItems;

  // Filter items from cartResponse or currentProduct based on keywords
  const availableFromCart = source?.filter((item: any) =>
    keywords?.some((keyword) => item?.productName?.toLowerCase().includes(keyword.toLowerCase()))
  );

  // Check for missing keywords in cart and handle them
  keywords?.forEach((keyword) => {
    const keywordInCart = availableFromCart?.some((item: any) =>
      item?.productName?.toLowerCase()?.includes(keyword?.toLowerCase())
    );

    // If not found in availableFromCart, look in existingOrderDetails
    if (!keywordInCart) {
      const sourceType = (keyword === "tech" || keyword===THIC || keyword===WIFI_EXTENDER) ? "additionalPlans" :  "standardPlans";
      
      let additonalPlan = existingOrderDetails?.additionalPlans
      additonalPlan = additonalPlan && additonalPlan.length ? additonalPlan.reduce((acc: any, item: any) => {
        const found = acc.find((obj: any) => obj?.additionalPlanName === item?.additionalPlanName);
        if (found) {
          found.count++
        } else {
          acc.push({ ...item, count:item?.quantity?item.quantity:1 })
        }
        return acc;
      }, []) : [];
     
      const planSource =
        (keyword === "tech" || keyword === THIC || keyword===WIFI_EXTENDER)
          ? additonalPlan
          : existingOrderDetails?.standardPlans;
      const plan = planSource?.find((plan: any) =>
        plan?.ratePlanName?.toLowerCase()?.includes(keyword.toLowerCase())
      );
      
      if (plan && !(keyword === "voice" && voiceRemoved)) {
        result.push({
          name: plan?.ratePlanName,
          price: sourceType !== "additionalPlans" ? `$${Math.abs(plan?.planPrice)?.toFixed(2)}` :  `$${(Math.abs(plan?.additionalPlanPrice)?.toFixed(2))}`,
        });
      }
    }
  });
  
    if (planDetailsData && Array.isArray(planDetailsData) && planDetailsData?.length && (sameProd)) {
      planDetailsData.forEach((itemData: any) => {
        const exists = result?.some((entry) => entry?.name === itemData?.planName);
        if (!exists) {
          result.push({
            name: itemData?.planName,
            price: `-$${Math.abs(itemData?.planDiscount)?.toFixed(2)}`,
            validthru: itemData?.effectiveEndDate
          });
        }
      });
    }


  // Add all matching items from the cart to the result
  availableFromCart?.forEach((item: any) => {
    if (voiceRemoved && item?.productName?.toLowerCase().includes("voice")) {
      return;
    }

    if(cartResponse && compareString(item?.productName,THIC) && item.itemActionType==="remove"){
      return;
    }
    if(cartResponse && compareString(item?.productName,"support") && item.itemActionType==="remove"){
      return;
    }
    const price = item?.displayLineItemPrice;
    //*********** Below code is not required */
    //const price = voiceRemoved
      // ? item?.priceResult?.length > 0 && item?.priceResult[0]?.productCharge || 0
      // :item?.displayLineItemPrice;

    result.push({
      name: item?.productName,
      price: `$${Math.abs(price)?.toFixed(2)}`,
    });
    // Check for "fiber" and integrate results from extractGigProducts
    if (item?.productName?.toLowerCase().includes("fiber")) {
      // const gigFlag = item?.productName?.toLowerCase().includes("1 gig") ? "1 gig" : "2 gig";
      const gigFlag = item?.productName?.toLowerCase()?.substring(15,);
       const extractedGigProducts = extractGigProducts(productRes?.productResponse, gigFlag);
       extractedGigProducts?.forEach((gigProduct:any) => {
        result.push({
          name: gigProduct?.name,
          price: `-$${Math.abs(gigProduct?.amount)?.toFixed(2)}`,
        });
      });
    }
    else if (isAffinityDiscountApplicable && currentProduct?.offerResponse === undefined){
      let currentinternetProducts = existingOrderDetails && existingOrderDetails?.standardPlans?.length && existingOrderDetails?.standardPlans?.find((productList: any, i: any) => (
        productList?.ratePlanName?.toLowerCase().includes("fiber") || productList?.planName?.toLowerCase().includes("fiber") || productList?.ratePlanName?.toLowerCase().includes("instant") || productList?.planName?.toLowerCase().includes("instant"))
      )
      const gigFlagName = currentinternetProducts !== undefined && currentinternetProducts?.planName?.toLowerCase()?.substring(15,)
      const extractedGigProducts = extractGigProducts(productRes?.productResponse, gigFlagName);
      extractedGigProducts?.forEach((gigProduct:any) => {
       const discountVal = result?.find((names:any) => names?.name === gigProduct?.name);
       discountVal === undefined && 
       result.push({
         name: gigProduct?.name,
         price: `-$${Math.abs(gigProduct?.amount)?.toFixed(2)}`,
       });
     });
    }
    
    // if (planDetailsData && Array.isArray(planDetailsData) && planDetailsData?.length && (sameProd)) {
    //   planDetailsData.forEach((itemData: any) => {
    //     const exists = result?.some((entry) => entry?.name === itemData?.planName);
    //     if (!exists) {
    //       result.push({
    //         name: itemData?.planName,
    //         price: `-$${Math.abs(itemData?.planDiscount)?.toFixed(2)}`,
    //         validthru: itemData?.effectiveEndDate
    //       });
    //     }
    //   });
    // }
  });


  // Add tax if voiceRemoved is false and "voice" is in the cart
  if (!voiceRemoved) {
    const voiceInCart = cartResponse?.lineItems?.some((item: any) =>
      item?.productName?.toLowerCase().includes("voice")
    );
    const vasInCart = cartResponse?.lineItems?.some((item: any) =>
      item?.productName?.toLowerCase().includes("brightspeed total home tech support")
    );
    if (voiceInCart || vasInCart) {
      result.push({
        name: csm,
        price: `$${Math.abs(cartResponse?.totalTaxToday)?.toFixed(2)}`,
      });
    }
  }
  // Sort result by priority: fiber, voice, tech, tax
const planNames = Array.isArray(planDetailsData)
  ? planDetailsData.map((item) => item?.planName?.toLowerCase())
  : [];

const discountPriority = (sameProd) ?  planNames : isAffinityApplicable ? ["discount"] : planNames;

const priority = [
  "fiber",
  "mbps",
  "credit",
  ...discountPriority, // Ensures discounts or planNames are correctly inserted
  "voice - standard",
  "wifi",
  "tech",
  "controls",
  "tax"
];

const sortedUniqueResult = result?.slice()
  .filter((item, index, self) => index === self.findIndex((t) => t.name === item.name)) // Removes duplicates
  .sort((a, b) => {
    const getPriorityIndex = (item: any) => {
      if (!item?.name) return Infinity;
      const lowerName = item?.name.toLowerCase();
      const index = priority?.findIndex((p) => lowerName?.includes(p));
      return index === -1 ? Infinity : index; // Ensures unmatched items go last
    };

    return getPriorityIndex(a) - getPriorityIndex(b);
  });

return sortedUniqueResult;
}




export const calculateDiscountAmount = (
  isAffinityApplicable: boolean,
  productDetail: any,
  defaultVoipCard: boolean,
  convertDollarFn: (value: any) => string
): { discountAmount: string; discountAmountWithoutDollar: number } => {
  if (!defaultVoipCard && isAffinityApplicable) {
    const actualCharge = productDetail?.priceResult[0]?.actualCharge || '00';
    const discountAmount = convertDollarFn(actualCharge);
    return {
      discountAmount,
      discountAmountWithoutDollar: parseFloat(discountAmount.replace("$", "")) || 0,
    };
  }
  return { discountAmount: '00', discountAmountWithoutDollar: 0 };
};

export const determineRegularPrice = (
  isAffinityApplicable: boolean,
  productDetail: any,
  defaultVoipCard: boolean
): number => {
  if (!defaultVoipCard && isAffinityApplicable) {
    return productDetail?.priceResult[0]?.productCharge || 0;
  }
  return !defaultVoipCard && (productDetail !== null || productDetail !== undefined) ? productDetail?.priceResult?.[0]?.productCharge : 0;
};



export const saveProductInCartStateUtil = (
  product: any,
  productDetail: any,
  activeAccordion: number,
  defaultVoipCard: boolean,
  isAffinityApplicable: boolean,
  discountAmount: any
) => {
  if (!defaultVoipCard) {
    const ProductName = productDetail?.productName || '';
    const RegularPrice = (!defaultVoipCard && productDetail?.priceResult[0]?.productCharge) || 0;
    const price = ((!defaultVoipCard && RegularPrice) || 0);
    const discountName = !defaultVoipCard && isAffinityApplicable ? productDetail?.affinity?.discountName : '';
    const ProductPrice = convertDollarPriceNoTrailingZeros(price);

    switch (activeAccordion) {
      case 1:
        return {
          internetProductId: productDetail?.billingRateProductId,
          internetProductName: ProductName,
          internetProductPrice: ProductPrice,
          discountAmount,
          discountName,
          isAffinityFromCatalogue: isAffinityApplicable,
        };
        
      case 2:
        return {
          // discountAmount,
          // discountName,
          // internetProductId: productDetail?.billingRateProductId,
          // internetProductName: ProductName,
          // internetProductPrice: ProductPrice,
          // isAffinityFromCatalogue: isAffinityApplicable,
          voipProductId: product?.billingRateProductId,
          voipProductName: ProductName,
          voipProductPrice: ProductPrice,
          installationProductName: ProductName,
          installationProductPrice: ProductPrice,
        };
        
      // case 3:
      //   return {
      //     voipProductId: product?.billingRateProductId,
      //     voipProductName: ProductName,
      //     voipProductPrice: ProductPrice,
      //     installationProductName: ProductName,
      //     installationProductPrice: ProductPrice,
      //   };

      default:
        return {};
    }
  } else {
    return {
      voipProductName: '',
      voipProductPrice: '',
    };
  }
};

function checkProductExist(existingProduct: any, cardType: string, product: any) {

  const existingProductMap: { [key: string]: number } = {};
  
  // Create a lookup table for existing products

  existingProduct?.forEach((item: any, index: number) => {

    existingProductMap[item?.productRatePlanId] = index;

  });

  let currentProductRatePlanId: any;

  if (cardType === "internet") {

    // Use find() to find the matching offerResponse
    const matchingOffer = product && product?.findIndex((offer: any) => {

      currentProductRatePlanId = offer?.offerResponse?.offerDetails?.billingRateProductId;

      return existingProductMap[currentProductRatePlanId] !== undefined;

    });

    if (matchingOffer >=0) {

      const existIndex = matchingOffer

      return { productExist: true, existIndex: existIndex };

    }

  } else if (cardType === "voice") {

  const matchingOffer = product && product?.findIndex((offer: any) => {

    currentProductRatePlanId = offer?.billingRateProductId;

    return existingProductMap[currentProductRatePlanId] !== undefined;

  });

  if (matchingOffer >= 0) {

    const existIndex = matchingOffer

    return { productExist: true, existIndex: existIndex };

  }
}

  return { productExist: false, existIndex: -1 };

}


function getInstallType(brsdIndicator: string) {
  brsdIndicator = brsdIndicator?.toUpperCase();
  if (brsdIndicator === "BF_QUALIFIED" || brsdIndicator === "QUALIFIED" || brsdIndicator === "QF_QUALIFIED" || brsdIndicator === "QF QUALIFIED") {
    return "self";
  } else {
    return "";
  }
}

function getAddressType(brightSpeedFiberIndicator: string) {
  brightSpeedFiberIndicator = brightSpeedFiberIndicator?.toUpperCase();
  if (brightSpeedFiberIndicator === 'BF_QUALIFIED' || brightSpeedFiberIndicator === 'QUALIFIED') {
    return "bs";
  } else if (brightSpeedFiberIndicator === 'QF_QUALIFIED' || brightSpeedFiberIndicator === 'QF QUALIFIED') {
    return "qf";
  } else if (brightSpeedFiberIndicator === 'COPPER') {
    return "ctl";
  } else {
    return "";
  }
}

const getProductStatus = (currentProductIndex: number, index: number, isProductExist: boolean,existingProducts:any,cardType="internet") => {
  if (currentProductIndex === -1) {
    return { recommended: false, productExist: false };
  }
  const recommended = (currentProductIndex + 1) === index;
  const productExist = (currentProductIndex === index && isProductExist);
  const plansWithPrices = existingProducts?.find((product:any) => {return product?.planName?.toLowerCase().includes(cardType); })?.planPrice;
  return { recommended, productExist, plansWithPrices };
};

const isConditionsMet = (
  lnpDetails: any,
  isLnpChoosen: string,
  productFlag: boolean,
  lnp: boolean,
  mandatory: boolean,
  voipServiceLimitationAgreement: boolean,
  cancelFlow: boolean,
 ): boolean => {
  const currentLineItem = lnpDetails?.currentLineItem || {};
  const hasValidLineItem = currentLineItem.id !== "" || currentLineItem.productCode !== "";
  return (
    ((currentLineItem?.productCode !== "" || currentLineItem.productCode !== undefined) && !productFlag && !cancelFlow) && 
    ((hasValidLineItem && isLnpChoosen === "Yes" && !lnp && !mandatory) || 
    (hasValidLineItem && isLnpChoosen === "Yes" && !lnpDetails.requiredFields) ||
    (hasValidLineItem && isLnpChoosen === "No"  && !voipServiceLimitationAgreement))
  );
 };

export const getCardClassName = (

  cardType: string,
  voiceRemoved: boolean,
  productExist: boolean,
  selectedProductDetail: any,
  productDetail: any,
  recommendedProduct: any,
   styles: any,
 ) => {

  const classes = ["cardChild", styles["AvailableProducts__card"], styles.regularCard, "regularCard"];
 
  // Determine active/inactive state

  const isActiveProduct = productDetail?.productCode === selectedProductDetail?.productCode;

  if (

    (cardType !== "voice" && isActiveProduct) ||

    (cardType === "voice" && !voiceRemoved && isActiveProduct)

  ) {

    classes.push("card-active");

  } else {

    classes.push("card-inactive");

  }
 
  // Determine currentCard state

  if (

    ((selectedProductDetail?.productCode === "" || selectedProductDetail?.productCode === undefined) &&

      productExist &&

      cardType !== "voice") ||

    (cardType === "voice" && !voiceRemoved && productExist)

  ) {

    classes.push("card-active", "currentCard");

  } else {

    classes.push("card-inactive");

  }
 
  // Add currentCard if product exists

  if (productExist) {

    classes.push("currentCard");

  }
 
  // Add selectedCard

  if (selectedProductDetail?.productCode === productDetail?.productCode && !productExist) {

    classes.push("selectedCard");

  }
 
  // Add recommendedCard

  if (recommendedProduct) {

    classes.push("recommendedCard");

  }
 
  // Add family and key-based classes

  if (isActiveProduct) {

    classes.push(`${productDetail?.productFamily}Card`);

    classes.push(`${productDetail?.productFamily}Card${productDetail?.key}`);

  }
 
  return classes.filter(Boolean).join(" ");

};
const replaceJSX = (text: any, find1: any, replace1: any, find2 = '', replace2 = '', find3 = '', replace3 = '', find4 = '', replace4 = '', find5 = '', replace5 = '') => {
  const output = text && text?.split(find1).flatMap((item: any) => [item, replace1]);
  output?.pop();
  if (find2 && replace2 && output[output?.length - 1]) {
    const output2 = output[output?.length - 1]
      .split(find2)
      .flatMap((item: any) => [item, replace2]);
    output2?.pop();
    output?.pop();
    if (find3 && replace3) {
      const output3 = output2?.pop()?.split(find3).flatMap((item: any) => [item, replace3]);
      output3?.pop();
      if (find4 && replace4) {
        const output4 = output3?.pop()?.split(find4).flatMap((item: any) => [item, replace4]);
        output4?.pop();
        if (find5 && replace5) {
          const output5 = output4?.pop()?.split(find5).flatMap((item: any) => [item, replace5]);
          output5?.pop();
          return [...output, ...output2, ...output3, ...output4, ...output5];
        }
        return [...output, ...output2, ...output3, ...output4];
      }
      return [...output, ...output2, ...output3];
    }
    return [...output, ...output2];
  }
  return output;

};

const getForIQRemove=(prevCart:any,updateCartResp:any)=>{
  let res;

  if(!Array.isArray(prevCart?.lineItems)){
    return updateCartResp;
  }
  if(!Array.isArray(updateCartResp?.lineItems)){
    return updateCartResp;
  }

  /*
  findIQ -  prevCart value has to remove THIC  
  findIQUpdate -  next updateCart  value has no remove THIC   
  */
 
  let findIQ = prevCart.lineItems.find((item:any)=>compareString(item.productName,"controls") && item.itemActionType==="remove");
  let findIQUpdate = updateCartResp.lineItems.find((item:any)=>compareString(item.productName,"controls") && item.itemActionType===undefined);

  let findTHTS = prevCart.lineItems.find((item:any)=>compareString(item.productName,"support") && item.itemActionType==="remove");
  let findTHTSUpdate = updateCartResp.lineItems.find((item:any)=>compareString(item.productName,"support") && item.itemActionType===undefined);

  let _updateCart=updateCartResp;

  if(findTHTS===undefined){
    res=updateCartResp;
  }

  /* case 1 if prev cart has nothing regarding thic remove return the latest updateCart api response */  
  if(findIQ===undefined){
    res=updateCartResp;
  }
  /* case 2 if next updateCart  has nothing regarding thic remove return the latest updateCart api response */
  else if(findIQUpdate===undefined){
    res=updateCartResp;
  }
  /* 
  case 3 if prevcart  has regarding thic remove and next update cart has nothing regarding THIC remove without change in thic section
  then - update the thic lineitem with prev thic lineitem
  */

  if(findIQ!==undefined && findIQUpdate!==undefined){

    _updateCart.lineItems=_updateCart?.lineItems?.map((item:any)=>{
      if(compareString(item?.productName,"controls")){
        item=findIQ;
      }
      return item;
    })
    res=_updateCart;
  }


  if(findTHTS!==undefined && findTHTSUpdate!==undefined){

    _updateCart.lineItems=_updateCart?.lineItems?.map((item:any)=>{
      if(compareString(item?.productName,"support")){
        item=findTHTS;
      }
      return item;
    })
    res=_updateCart;
  }
  return res;
}

const getVoiceToadd=(cart:any,existing:any)=>{
  let sendvoiceToAdd=false;
  let voiceToAdd = cart?.lineItems?.find((item:any)=>compareString(item?.productName,"voice"));
  let voiceExist = existing?.standardPlans?.find((item:any)=>compareString(item?.ratePlanName,"voice"));


  if(voiceExist===undefined && voiceToAdd!==undefined){
    sendvoiceToAdd=true;
  }

  return sendvoiceToAdd;
}

const checkIfWeHaveOweToday=(selectedInternetProduct:any,selectedVoiceProduct:any,hasTHTS:any,hasTHIC:any,internetExist:any,cancelFlow:any)=>{
  let haveOwe=false;
  if (selectedInternetProduct && Object.keys(selectedInternetProduct)?.length > 0 && !internetExist) {
    selectedInternetProduct?.map((productList: any, i: any) => {
      if (productList?.productName?.toLowerCase()?.includes("fiber")){
        haveOwe=true;
      }
    });
  }
  if (selectedVoiceProduct &&  (Object.keys(selectedVoiceProduct)?.length > 0 && !cancelFlow)) {
    selectedVoiceProduct?.map((productList: any, i: any) => {
      if(productList?.productName?.toLowerCase()?.includes("voice")){
        haveOwe=true;
      }
    })
  }

  if(hasTHTS){
    haveOwe=true;
  }
  if(hasTHIC){
    haveOwe=true;
  }

  return haveOwe;
}

export { formatProductName, checkProductExist, getInstallType, getAddressType, getProductStatus, isConditionsMet, replaceJSX, getForIQRemove, getVoiceToadd, checkIfWeHaveOweToday};
